import { render, staticRenderFns } from "./BackArrowComp.vue?vue&type=template&id=4f50abd2&scoped=true&lang=pug&"
import script from "./BackArrowComp.vue?vue&type=script&lang=ts&"
export * from "./BackArrowComp.vue?vue&type=script&lang=ts&"
import style0 from "./BackArrowComp.vue?vue&type=style&index=0&id=4f50abd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50abd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
